import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import StudentDisplay from "@/pages/StudentDisplay";
import TeacherPanel from "@/pages/TeacherPanel";
import AudioStudio from "@/pages/AudioStudio";
import SlidePreview from "@/pages/SlidePreview";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/student" element={<StudentDisplay />} />
                    <Route path="/teacher" element={<TeacherPanel />} />
                    <Route
                        path="/student-display"
                        element={<StudentDisplay />}
                    />
                    <Route
                        path="/teacher-panel"
                        element={<TeacherPanel />}
                    />
                    <Route path="/audio-studio" element={<AudioStudio />} />
                    <Route
                        path="/slide-preview"
                        element={<SlidePreview />}
                    />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
